(function() {
    'use strict';

    angular.module("imApp").factory("consignmentDeliveryConfirmService", ['$ihttp', function ($ihttp) {
        let service = {
            getInfo: function (parms) {
                return $ihttp.post({
                    method: 1979,
                    parameters: parms || {}
                });
            },
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 922,
                    parameters: parms || {}
                });
            },
            saveAndConfirmObj: function (inputListCheckListDatas) {
                return $ihttp.post({
                    method: 1982,
                    parameters: inputListCheckListDatas
                });
            },
            saveAndConfirmWithDeviationObj: function (inputListCheckListDatas) {
                return $ihttp.post({
                    method: 1983,
                    parameters: inputListCheckListDatas
                });
            }
        };

        return service;
    }]);
})();
